"use client";

import Cookies from "js-cookie";
import { ADMIN_AUTH_COOKIE_NAME, AUTH_COOKIE_NAME } from "@shared/src/constants/auth";
import { useHostStore } from "@shared/src/stores/useHostStore";

interface AuthCookie {
  jwt: string;
  merchantId: `0x${string}`;
}

export const cookieManager = () => {
  const setAuthToken = (token: string, merchantId: `0x${string}`) => {
    const sdk = useHostStore.getState().sdk;
    sdk?.auth.setAuthToken(token);
    const authData: AuthCookie = { jwt: token, merchantId };
    Cookies.set(AUTH_COOKIE_NAME, JSON.stringify(authData), {
      path: "/",
      secure: process.env.NODE_ENV === "production",
      sameSite: "strict",
      expires: 7,
    });
  };

  const setAdminAuthToken = (token: string) => {
    const sdk = useHostStore.getState().sdk;
    if (!sdk) throw new Error("SDK not found setting admin auth token");
    sdk.auth.setAdminToken(token);

    Cookies.set(ADMIN_AUTH_COOKIE_NAME(sdk.env), token, {
      path: "/",
      secure: process.env.NODE_ENV === "production",
      sameSite: "strict",
      expires: 7,
    });
  };

  const getAuthToken = () => {
    const authData = Cookies.get(AUTH_COOKIE_NAME);
    if (!authData) return useHostStore.getState().sdk?.auth.getToken() || null;
    try {
      return JSON.parse(authData).jwt as string;
    } catch (e) {
      return null;
    }
  };

  const getAdminAuthToken = () => {
    const sdk = useHostStore.getState().sdk;
    if (!sdk) return null;

    return Cookies.get(ADMIN_AUTH_COOKIE_NAME(sdk.env));
  };

  const getMerchantId = () => {
    const authData = Cookies.get(AUTH_COOKIE_NAME);
    if (!authData) return null;
    try {
      return useHostStore.getState().sdk?.auth.getAddress();
    } catch (e) {
      return null;
    }
  };

  const removeAuth = () => {
    Cookies.remove(AUTH_COOKIE_NAME);
  };

  const removeAdminAuth = () => {
    const sdk = useHostStore.getState().sdk;
    if (!sdk) throw new Error("SDK not found removing admin auth token");
    Cookies.remove(ADMIN_AUTH_COOKIE_NAME(sdk.env));
  };

  return {
    setAuthToken,
    getAuthToken,
    getMerchantId,
    setAdminAuthToken,
    getAdminAuthToken,
    removeAuth,
    removeAdminAuth,
  };
};
